<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Withdrawal - Upload Document')}}</h3>
                <span class="fz-16 fw-400">{{ $t('Upload Your Document for Verification') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="overflow-auto">
                <b-row class="my-4 pt-2 pb-5">
                    <b-col cols="12">
                        <label>{{ $t('Image/Document File') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                                <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                        </span>
                        <NewPopupInfo :name="'voucher'" v-if="showPopup"></NewPopupInfo>
                    </b-col>

                    <b-col cols="12" class="mb-5">
                        <FileUploader :type="'browse'" :ref="'document'" :allowed_types="['pdf','rar', 'zip']" :size="10 * 1024 * 1024"
                            @capture-file="captureFile($event)" @remove-image="removeImage($event)">
                        </FileUploader>
                        <div v-if="error['image']" class="invalid-feedback d-block mb-3">
                            {{ $t(error['image']) }}
                        </div>
                    </b-col>

                    <b-col cols="12" class="text-right">
                        <button class="btn btn-primary d-block" @click="submit">{{ $t('Submit') }}</button>
                    </b-col>
                </b-row>
            </div>
        </b-container>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import Withdrawal from "@/services/Withdrawal";

export default {
    name: 'withdrawal-supporting-document',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            showPopup: false,
            image: '',
            error: {
                image: ''
            }
        }
    },
    components: {
        LoaderComponent,
        FileUploader,
        NewPopupInfo
    },
    methods: {
        getMessage: function (key) {
            return this.$t(key)
        },
        checkError(err) {
            try {
                let self = this;
                const response = err.response;
                if (response.status == 400) {
                    if (typeof response.data.message === 'string') {
                        this.$notify({
                            type: 'warn',
                            text: response.data.message
                        });
                    }
                    else {
                        if (response.data.message['file']) {
                            let fileList = response.data.message['file'];
                            for (let i = 0; i < fileList.length; i++) {
                                if (fileList[i].type == 32) {
                                    self.error.image = fileList[i].message;
                                }
                            }
                        }
                        self.success = false;
                        self.$emit('file-uploaded');
                    }
                }
                else if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: '/login',
                    });
                }
                else {
                    if (localStorage.getItem("token")) {
                        var msg = (response.data) ? response.data.message : err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            } catch (e) {
                console.log(err);
            }
        },
        submit() {
            if (this.image) {
                this.isLoading = true;
                Withdrawal.uploadPDF({
                    "orderId": this.$route.query.id,
                    "fileUpload": [
                        {
                            "category": "upload document",
                            "type": 32,
                            "file": this.image
                        }
                    ]
                }).then((response) => {
                    if (response.status == 200) {
                        this.isLoading = false;

                        this.$swal({
                            icon: 'success',
                            title: this.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            this.$router.push({
                                path: '/withdrawal'
                            });
                        });
                    }
                }).catch(err => {
                    this.isLoading = false;
                    this.checkError(err);
                });
            }
            else {
                this.error.image = "can not blank";
            }
        },
        onChange(name) {
            this.error[name] = "";
        },
        togglePopup() {
            this.showPopup = !this.showPopup;
        },
        captureFile($event) {
            this.error.image = "";
            this.image = $event;
        },
        removeImage($event) {
            this.image = "";
            this.error.image = "";
        },
        init() {

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    }
};
</script>

<style scoped>
#body-container {
    min-height: 80vh;
}

.d-block {
    display: block !important;
}

.btn-primary.d-block {
    width: 100%;
}

.popup-info {
    transform: unset !important;
}
</style>